import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SolarApplicationsService } from 'src/app/services/service-provider.service';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss'],
})
export class ActionComponent implements OnInit {
  showPopup: boolean = false;
  popupType: 'reset' | 'update' = 'reset';
  solarRequestData: any;
  applicationStates: any[] = [];
  selectedStateId: number | null = null;
  selectedStateName: string = "";

  constructor(
    private route: ActivatedRoute,
    private solarService: SolarApplicationsService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      const userId = params['applicationId'];
      this.loadUserSolarRequest(userId);
    });
  }

  loadUserSolarRequest(userId: string) {
    this.solarService.getUserSolarRequest(userId).subscribe(
      (response) => {
        this.updateSolarRequestData(response);
      },
      (error) => {
        console.error('Error fetching solar request data:', error);
      }
    );
  }

  openPopup(type: 'reset' | 'update') {
    this.popupType = type;
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
    if (this.popupType === 'update') {
      this.selectedStateId = null;
    }
  }

  onConfirm() {
    if (this.popupType === 'reset') {
      this.onConfirmReset();
    } else {
      this.onConfirmUpdate();
    }
  }

  onConfirmReset() {
    if (this.solarRequestData) {
      this.solarService.resetSolarRequest(this.solarRequestData.id).subscribe(
        (response) => {
          this.updateSolarRequestData(response);
          this.closePopup();
        },
        (error) => {
          console.error('Error resetting solar request:', error);
        }
      );
    }
  }

  onConfirmUpdate() {
    if (this.selectedStateId && this.solarRequestData) {
      this.solarService.updateSolarRequestState(this.solarRequestData.id, this.selectedStateId).subscribe(
        (response) => {
          this.updateSolarRequestData(response);
          this.closePopup();
        },
        (error) => {
          console.error('Error updating solar request state:', error);
        }
      );
    }
  }

  updateSolarRequestData(response: any) {
    this.solarRequestData = response.item;
    this.applicationStates = response.application_states;
    this.selectedStateId = null;
  }

  getStatusClass(status: string): string {
    return status.toLowerCase().replace(' ', '-');
  }

  canUpdate(status: string): boolean {
    return status.toLowerCase() === 'next action';
  }

  toggleStateSelection(stateId: number) {
    if (this.selectedStateId === stateId) {
      this.selectedStateId = null;
    } else {
      this.selectedStateId = stateId;
    }
    this.selectedStateName = this.applicationStates.find(state => state.id === stateId)?.state 
  }

  isStateSelected(stateId: number): boolean {
    return this.selectedStateId === stateId;
  }
}